<script setup lang="ts">
    import { computed } from 'vue';
    import { VatSubmission } from '@/types';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import SubmitVat from './SubmitVat.vue';
    import EditVat from './EditVat.vue';
    import type { Table, Row } from '@tanstack/vue-table';

    const props = defineProps<{
        vatSubmission: VatSubmission;
        row: Row<VatSubmission>;
        table: Table<VatSubmission>;
    }>();

    const isDeadlinePassed = computed(() => {
        if (!props.vatSubmission.deadline) {
            return false;
        }

        const deadline = new Date(props.vatSubmission.deadline);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        deadline.setHours(0, 0, 0, 0);

        return deadline < today;
    });

    const canEdit = computed(() => {
        return (
            !isDeadlinePassed.value &&
            props.vatSubmission.status === 'submitted' &&
            !props.vatSubmission._is_editing
        );
    });

    const canSubmit = computed(() => {
        return (
            !isDeadlinePassed.value &&
            (props.vatSubmission.status === 'draft' || props.vatSubmission._is_editing)
        );
    });
</script>

<template>
    <DataTableActions :data="vatSubmission">
        <EditVat
            v-if="canEdit"
            :table="table"
            :row="row"
        />
        <SubmitVat
            v-if="canSubmit"
            :vat-submission="vatSubmission"
        />
    </DataTableActions>
</template>
